import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  // Initialize to auto-detect mode on first load
  useEffect(() => {
    if (!localStorage.getItem('languageMode')) {
      localStorage.setItem('languageMode', 'auto');
      i18n.changeLanguage('en'); // Default UI to English for auto-detect
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    if (lng === 'auto') {
      localStorage.setItem('languageMode', 'auto');
      localStorage.removeItem('i18nextLng'); // Clear manual language selection
      i18n.changeLanguage('en'); // Keep UI in English for auto-detect mode
    } else {
      i18n.changeLanguage(lng);
      localStorage.setItem('i18nextLng', lng);
      localStorage.setItem('languageMode', 'manual');
    }
  };

  // Check current mode and language
  const languageMode = localStorage.getItem('languageMode') || 'auto';
  const currentValue = languageMode === 'auto' ? 'auto' : i18n.language;

  return (
    <label style={{ fontSize: "14px", display: "flex", alignItems: "center" }}>
      Language:&nbsp;
      <select
        onChange={(e) => changeLanguage(e.target.value)}
        value={currentValue}
        aria-label="Select Language"
        style={{ fontSize: "14px" }}
      >
        <option value="auto">Auto-detect</option>
        <option value="en">English</option>
        <option value="sw">Kiswahili (Swahili)</option> 
        <option value="zh">中文 (Chinese)</option>
        <option value="ar">العربية (Arabic)</option>
        <option value="es">Español (Spanish)</option>
        <option value="hi">हिन्दी (Hindi)</option>
        <option value="vi">Tiếng Việt (Vietnamese)</option>
      </select>
    </label>
  );
};

export default LanguageSelector;